"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n            display: inline-block;\n            margin: ", "em;\n            padding ", "em;\n            text-decoration: none;\n            color: ", ";\n            text-transform: ", ";\n            &:first-child {\n                margin-left: 0;\n            }\n            &.active{\n                box-shadow: inset 0px -5px ", ";\n            }\n        "], ["\n            display: inline-block;\n            margin: ", "em;\n            padding ", "em;\n            text-decoration: none;\n            color: ", ";\n            text-transform: ", ";\n            &:first-child {\n                margin-left: 0;\n            }\n            &.active{\n                box-shadow: inset 0px -5px ", ";\n            }\n        "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRouterDom = require("react-router-dom");

var _theme = require("../../theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MainNavLink = (0, _styledComponents2.default)(_reactRouterDom.NavLink).attrs({
    exact: true,
    activeClassName: "active"
})(_templateObject, function (props) {
    return props.theme.navigation.navLink.margin;
}, function (props) {
    return props.theme.navigation.navLink.padding;
}, function (props) {
    return props.theme.navigation.navLink.color;
}, function (props) {
    return props.theme.navigation.navLink.textTransform;
}, function (props) {
    return props.theme.navigation.navLink.activeColor;
});

MainNavLink.displayName = "MainNavLink";

MainNavLink.propTypes = {};

MainNavLink.defaultProps = {};
exports.default = MainNavLink;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/navigation/MainNavLink.js
// module id = 1015
// module chunks = 95715928098905 168707334958949